// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2548":"a1939738","6641":"b848cd81","8410":"a1939738","8682":"a1939738"}[chunkId] + ".chunk.css";
};